module.exports = __webpack_public_path__ + "static/media/Vliegtuig_in_de_lucht.0f5abb84.mp3";